import { t } from '@lingui/core/macro';
import { Alert } from '@pocketlaw/tetris';
export function CreateErrorAlert() {
    return (<Alert appearance="danger" title={t({
            message: 'Could not create project',
            comment: 'Create project dialog - Error alert title',
        })} message={t({
            message: 'Something went wrong when trying to create the project, please try again.',
            comment: 'Create project dialog - Error alert message',
        })}/>);
}
